<template>
  <div>
    <h5 class="is-size-5 has-text-centered">
      {{ doc.name }}
    </h5>

    <div class="columns">
      <div class="column">
        <div class="buttons is-pulled-right">
          <b-button
            tag="router-link"
            icon-left="chart-donut"
            :to="{ name: 'operatorOverview', params: { id: doc.id }}"
          >
            {{ $t('operators.overview') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <a-card :editable="false">
          <a-input
            field="name"
            type="text"
          />

          <a-taginput
            field="vehicleTypes"
            options="vehicleTypes"
          />

          <depots
            v-if="doc.depots"
          />

          <contacts
            v-if="keys(doc.contacts).length"
          />
        </a-card>
      </div>

      <div class="column">
        <a-input
          field="officialName"
        />

        <a-input
          field="address"
        />

        <a-input
          field="city"
        />

        <a-input
          field="zip"
        />

        <a-autocomplete
          field="country"
          :options="countries"
          option-label="country"
        />

        <a-input
          field="regNr"
        />

        <a-input
          field="vatNr"
        />
      </div>
    </div>
    <add-button />
  </div>
</template>

<script>
import { keys } from 'lodash'
import Contacts from '@/components/Contacts/Contacts'
import formMixin from './formMixin'
import AddButton from './Operator/AddButton'
import Depots from './Operator/Depots'

export default {
  components: {
    AddButton,
    Depots,
    Contacts
  },
  mixins: [formMixin],
  computed: {
    countries () {
      return _.sortBy(_.uniqBy(this.$store.getters['operators/items'], 'country'), 'country')
    }
  },
  methods: {
    keys
  }
}
</script>
